'use client'

import { useEffect } from 'react'

import { useChangeBaseColor } from '@/hooks/useChangeBaseColor'

export function BaseColorSetter() {
  useChangeBaseColor('bg-theme-light')
  return null
}
